var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.label)?_c(_setup.RmpText,{attrs:{"tag":"span","type":"body-large","color":_setup.colors.grey.darken1}},[_c('span',{staticClass:"mr-1"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(_vm.required)?_c('span',{staticClass:"error--text"},[_vm._v("*")]):_vm._e(),_vm._v(" "),_vm._t("append")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }